import type { IconNode } from '../types';

/**
 * @name hat-beanie
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAuNCA2LjJDNi43IDYuOSA0IDEwLjEgNCAxNHYxIiAvPgogIDxjaXJjbGUgY3g9IjEyIiBjeT0iNSIgcj0iMiIgLz4KICA8cGF0aCBkPSJNMjAgMTV2LTFjMC0zLjktMi43LTcuMS02LjQtNy44IiAvPgogIDxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSI1IiB4PSIyIiB5PSIxNSIgcng9IjEiIC8+CiAgPHBhdGggZD0iTTYgMTV2NSIgLz4KICA8cGF0aCBkPSJNMTAgMTV2NSIgLz4KICA8cGF0aCBkPSJNMTQgMTV2NSIgLz4KICA8cGF0aCBkPSJNMTggMTV2NSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/hat-beanie
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const hatBeanie: IconNode = [
  ['path', { d: 'M10.4 6.2C6.7 6.9 4 10.1 4 14v1', key: '9387br' }],
  ['circle', { cx: '12', cy: '5', r: '2', key: 'f1ur92' }],
  ['path', { d: 'M20 15v-1c0-3.9-2.7-7.1-6.4-7.8', key: '1o2bc8' }],
  ['rect', { width: '20', height: '5', x: '2', y: '15', rx: '1', key: 'noh35d' }],
  ['path', { d: 'M6 15v5', key: '12y8bp' }],
  ['path', { d: 'M10 15v5', key: '13p7r0' }],
  ['path', { d: 'M14 15v5', key: '1271wn' }],
  ['path', { d: 'M18 15v5', key: 'hb43h5' }],
];

export default hatBeanie;
